// extracted by mini-css-extract-plugin
module.exports = {"text_icon":"Texticon--text_icon--1_D9f","icon_heading":"Texticon--icon_heading--2vFIo"};